module.exports = __webpack_public_path__ + "assets/htu-6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-6.jpg
// module id = 1193
// module chunks = 7